function cov_eigk9xq9() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Notification.tsx";
  var hash = "2d3bb7ed4b60260bbfcc137fa0c474424a465991";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Notification.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 52
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2d3bb7ed4b60260bbfcc137fa0c474424a465991"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_eigk9xq9 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_eigk9xq9();
var Icon = (cov_eigk9xq9().s[0]++, {
  name: 'notification',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.4141 13.5598C21.5462 13.8273 21.7387 14.0605 21.9763 14.2408L22.8131 14.8889C23.0748 15.0848 23.2869 15.3395 23.4322 15.6323C23.5775 15.9252 23.6521 16.2481 23.6499 16.575C23.6549 16.8441 23.6067 17.1115 23.5081 17.3619C23.4096 17.6123 23.2626 17.8408 23.0756 18.0342C22.8885 18.2277 22.6651 18.3823 22.4182 18.4893C22.1713 18.5963 21.9056 18.6534 21.6366 18.6575H3.01983C2.75048 18.6534 2.48456 18.5963 2.23728 18.4894C1.99001 18.3825 1.7662 18.228 1.57866 18.0346C1.39111 17.8412 1.24351 17.6128 1.14427 17.3624C1.04502 17.1119 0.996082 16.8444 1.00024 16.575C0.999261 16.2476 1.075 15.9246 1.22141 15.6318C1.36782 15.339 1.58082 15.0845 1.84331 14.8889L2.68008 14.2597C2.91774 14.0793 3.11023 13.8462 3.24235 13.5787C3.37446 13.3112 3.4426 13.0166 3.44138 12.7183V11.4914C3.42681 9.64797 3.96915 7.84306 4.99745 6.31296C6.02574 4.78287 7.49205 3.59889 9.20443 2.91602C9.49759 2.33949 9.94459 1.85533 10.4959 1.51716C11.0473 1.17899 11.6814 1 12.3282 1C12.975 1 13.6092 1.17899 14.1605 1.51716C14.7118 1.85533 15.1588 2.33949 15.452 2.91602C17.1649 3.59816 18.6317 4.78196 19.6601 6.31222C20.6885 7.84247 21.2305 9.64777 21.2151 11.4914V12.6994C21.2138 12.9978 21.282 13.2923 21.4141 13.5598ZM10.2436 22.2792C9.6502 21.8123 9.23106 21.1594 9.05352 20.4255H15.5967C15.4192 21.1594 15.0001 21.8123 14.4067 22.2792C13.8133 22.7461 13.0802 23 12.3251 23C11.5701 23 10.8369 22.7461 10.2436 22.2792Z\" fill=\"currentColor\"/>"
});
export default Icon;